const cache = { list: null, videoFileName: null };

export const getEmbeddedCache = () => cache;

export const setEmbeddedCache = (list, videoFileName) => {
  cache.list = list;
  cache.videoFileName = videoFileName;
};

export const clearEmbeddedCache = () => {
  cache.list = null;
  cache.videoFileName = null;
};

export const isEmbeddedCacheValid = (videoFileName) => {
  return cache.videoFileName === videoFileName && cache.list !== null;
};
